define('lq/events/actions/changeParameter',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    var shouldSetParameter = function (options, targetParameters) {
        if (options.updateType === 'always') {
            return true;
        }

        var value = targetParameters.getValue(options.parameter);
        return value === null || value === undefined;
    };

    function ChangeParameter(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(ChangeParameter, EventAction);

    ChangeParameter.typeName = 'ChangeParameter';

    ChangeParameter.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };
    
    ChangeParameter.prototype.execute = function (continuation) {
        var self = this;

        var options = self.eventData.setParameter;
        
        var targetParameters = options.global
            ? this.piping.parameters.globals
            : this.piping.parameters.locals;

        if (options.updateType === 'remove') {
            targetParameters.remove(options.parameter);
        } else if (options.updateType === 'clear') {
            targetParameters.clear(options.parameter);
        } else if (shouldSetParameter(options, targetParameters)) {
            targetParameters.setValue(options.parameter, options.value);
	    }

	    continuation();
    };

    return ChangeParameter;
});
